import type { TransportNeedGraphPoint } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/types";
import type { AltTransIncidentPassengerPredictions } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";

/**
 * Transforms PassengerPredictionsResponse to graph points,
 * grouped by stretch
 */
export function transformPredictionsToChartData(
  response: AltTransIncidentPassengerPredictions,
): { [stretchName: string]: TransportNeedGraphPoint[] } {
  if (!response) {
    return {};
  }

  return Object.fromEntries(
    response.prediction.stretchPredictions.map((measureStretch) => {
      const stretch = `${measureStretch.fromStop?.jbvId}–${measureStretch.toStop?.jbvId}`;

      return [
        stretch,
        measureStretch.predictions.map((prediction) => ({
          date: new Date(prediction.fromTime),
          passengers: prediction.passengersRequiringTransport ?? 0,
        })),
      ];
    }),
  );
}
